import React from "react";
import { Outlet } from "react-router-dom";

const BasePage = () => (
  <div className="wrapper">
    <Outlet />
  </div>
);

export default BasePage;
